export enum eFlow {
  ValidaciónAsn = 1,
  ValidacionRutaPicking,
  ValidacionDespacho,
  ValidacionDespachoDeclararError,
  RutaPickingSaltoPosición,
  RutaPickingSinUnidades,
  AjusteSkuDevolución,
  AlmacenamientoExterno
}
